export default __webpack_public_path__ + "static/media/Chelsea.df512c61.svg";